import axios from 'axios/dist/axios.min'

export const initializeActiveTab = ({commit}) => {
  commit('changeActiveTab', 0);
};
export const selected_category = ({commit}, category) => {
	document.documentElement.classList.remove('uk-modal-page');	// モーダルを閉じるアニメーション前に遷移するので処理しておく
  commit('setCartCategory', category);
  commit('changeActiveTab', 1);
};
export const selected_figure = ({commit, state}, figure) => {
	document.documentElement.classList.remove('uk-modal-page');	// モーダルを閉じるアニメーション前に遷移するので処理しておく
  if (state.cart.figure && figure.id != state.cart.figure.id){
    commit('clearPacks');
  }
  commit('setCartFigure', figure);
  commit('changeActiveTab', 2);
};
export const selected_design = ({commit, state}, design) => {
	document.documentElement.classList.remove('uk-modal-page');	// モーダルを閉じるアニメーション前に遷移するので処理しておく
	if (state.cart.design === null || (state.cart.design && design.id !== state.cart.design.id) ){
		commit('clearParts');
		commit('clearLetters');
	}
	commit('setCartDesign', design);
	commit('changeActiveTab', state.product_tab.activeIndex);
	commit('clearActiveTab');
};
export const openModal = ({commit}, params) => {
  commit('openModal', params);
};
export const closeModal = ({commit}) => {
  commit('closeModal');
};

